import {
    memo,
    InputHTMLAttributes,
    FunctionComponent,
} from 'react';

// Components
import { Dropdown } from 'reactstrap';
import Input from './Input';

// Utilities
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';
import { useInputSearch, withInputSearchManager } from '@Components/Layout/Search/Components/InputSearch/Contexts';

// Styles
import styles from './Style.module.scss';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export interface HistorySearchItem {
    id?: string;
    term?: string;
    [key: string]: any;
}

export interface InputSearchProps extends InputHTMLAttributes<HTMLInputElement> {
    type?: string;
    keyword?: string;
    className?: string;
    placeholder?: string;
    showMobile?: boolean;
    showFilter?: boolean;
    buttonStyle?: string;
    btnSearchMobile?: boolean;
}

const InputSearch: FunctionComponent<InputSearchProps> = memo(
    ({
        className,
        showMobile,
        showFilter,
        placeholder,
        buttonStyle,
        btnSearchMobile,
        ...props
    }) => {
        const { deviceType } = useViewDetected();

        const {
            value,
            isEmpty,
            isFocusSearch,
            listHistorySearch,

            handleFocus,
            handleChange,
            handleClickSearch,
            handleToggleFocus,
            handleChooseSearch,
            handleDeleteHistory,
        } = useInputSearch();

        const wrapperClassName = classnames([
            styles.wrapper,
            {
                [styles.show_mobile]: showMobile,
                [styles.with_icon_right]: showFilter,
                [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
            },
            className,
        ]);

        const inputSearchClassName = classnames([
            styles.input_wrapper,
            {
                [styles.input_focus]: isFocusSearch && isEmpty && listHistorySearch?.length > 0,
            },
        ]);

        const btnSearchClassName = classnames([
            styles.btn_search,
            buttonStyle,
            { [styles.btn_mobile]: btnSearchMobile },
        ]);

        return (
            <form className={wrapperClassName} onSubmit={handleClickSearch}>
                <Dropdown isOpen={isFocusSearch} toggle={handleToggleFocus} className={inputSearchClassName}>
                    <Input
                        {...props}
                        type="text"
                        value={value}
                        onFocus={handleFocus}
                        onChange={handleChange}
                        placeholder={placeholder}
                        onChooseSearch={handleChooseSearch}
                        listHistorySearch={listHistorySearch}
                        onDeleteHistory={handleDeleteHistory}
                    />
                </Dropdown>

                <button className={btnSearchClassName} type="submit">
                    {btnSearchMobile ? (
                        <FontAwesomeIcon className={styles.icon_btn_search} icon={faSearch} />
                    ) : (
                        'Tìm kiếm'
                    )}
                </button>
            </form>
        );
    },
);

InputSearch.defaultProps = {
    keyword: '',
    className: '',
    buttonStyle: '',
    showMobile: true,
    showFilter: false,
    btnSearchMobile: false,
};

export default withInputSearchManager(InputSearch);
